export default class Trip {
    offset = 150;

    init() {
        if (window.innerWidth < 760) {
            this.offset = 60;
        }

        const position = new URLSearchParams(window.location.search).get('position');
        if (position) {
            this.scrollToElement(position);
        }
    }

    scrollToElement(id) {
        let el = document.getElementById(id);
        if (el) {
            window.scrollTo({ top: el.offsetTop - this.offset, behavior: 'smooth' });
        }
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('trip', () => new Trip());
});